
const config = {
    // defaultImg: 'https://srt-read-online.3ren.cn/headimg/15380393100165xkTSS6Iww.png?x-oss-process=image/resize,h_500', // 默认头像
    defaultImg: 'https://srtupload.jsyxw.cn/basebusiness/other/2026/03/04/15/f5337749-1bf6-4aa9-b3d7-46eab538eaa1.png', // 默认头像
    defaultLogo: 'https://d1.3ren.cn/static/front-res/grain-wand-web/web-logo.png' // 默认logo
}

export default config;